module.exports = __webpack_public_path__ + "media/packs/images/flags/BG-833088e09eb3770f22a58cf7961a3fd0.png";